import { render, staticRenderFns } from "./submissionPanel.vue?vue&type=template&id=919239d6&scoped=true&"
import script from "./submissionPanel.vue?vue&type=script&lang=ts&"
export * from "./submissionPanel.vue?vue&type=script&lang=ts&"
import style0 from "./submissionPanel.vue?vue&type=style&index=0&id=919239d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919239d6",
  null
  
)

export default component.exports